export function accueilSlider(){
	
	let slid = jQuery(".accueil-slider-element");
	let dot = jQuery(".accueil-slider-nav-dot");
	dot.eq(0).addClass("active");
	
	slid.slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000
	});
	

	jQuery(".accueil-slider-element").on('afterChange', function(event, slick, currentSlide){
		dot.removeClass("active");	
		dot.eq( currentSlide  ).addClass('active');
	});

	
	jQuery("#accueil-slider-nav-dots").on("click", ".accueil-slider-nav-dot", function(e) {
		e.preventDefault();
		dot.removeClass("active");
		jQuery(this).addClass('active');
		
		let ind = jQuery(this).index();
		slid.slick('slickGoTo',ind);
	});
	
	jQuery(".hero-slider-nav").on("click", ".nav-left", (e) => {
		e.preventDefault();
		slid.slick('slickPrev');
	});
	jQuery(".hero-slider-nav").on("click", ".nav-right", (e) => {
		e.preventDefault();
		slid.slick('slickNext');
	});	
}